export default function JourneySections({ journey, onSelectCheckpoint }) {
  const upcoming = journey.checkpoints.filter((checkpoint) => checkpoint.state !== 'done').slice(0, 4);
  const finished = journey.checkpoints.filter((checkpoint) => checkpoint.state === 'done');
  const earnedMedals = journey.medals.filter((medal) => finished.some((checkpoint) => checkpoint.id === medal.id));
  return (
    <div className="journey-sections">
      <section className="journey-section htv-card">
        <h2>Các chặng sắp tới</h2>
        <div className="checkpoint-rail">
          {upcoming.map((checkpoint) => (
            <button key={checkpoint.id} type="button" onClick={() => onSelectCheckpoint(checkpoint)}>
              <strong>{checkpoint.name}</strong>
              <span>
                {checkpoint.distanceKm} km · {checkpoint.location}
              </span>
            </button>
          ))}
        </div>
      </section>

      <section className="journey-section htv-card">
        <h2>Huân chương đã đạt</h2>
        <div className="medal-grid">
          {journey.medals.map((medal) => (
            <div className={earnedMedals.some((earnedMedal) => earnedMedal.id === medal.id) ? 'medal-card medal-card-earned' : 'medal-card'} key={medal.id}>
              <span>★</span>
              <strong>{medal.name}</strong>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
